import { Warning } from "@phosphor-icons/react";
import { STATUS_BY_ID } from "./callListConstants";

/**
 * DuplicateAlert — Vague 8.
 *
 * When a colleague has already called this business in the past 7 days,
 * we show a soft warning so the télépro can adapt their pitch
 * (« bonjour, un collègue vous a peut-être appelé la semaine dernière… »)
 * or skip the fiche if a Refus was already recorded.
 *
 * Props :
 *   calls    — array of {telepro_code, status, at, note} sorted DESC
 *   testid   — root data-testid
 */
function _relDay(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const now = new Date();
  const diffH = Math.max(0, (now - d) / 36e5);
  if (diffH < 24) return "aujourd'hui";
  if (diffH < 48) return "hier";
  const days = Math.floor(diffH / 24);
  return `il y a ${days} j`;
}

export function DuplicateAlert({ calls, testid = "dup-alert" }) {
  if (!calls || calls.length === 0) return null;
  const last = calls[0];
  const status = STATUS_BY_ID[last.status];
  const statusLabel = status?.short || status?.label || last.status;
  const others = calls.length > 1 ? ` + ${calls.length - 1} autre${calls.length > 2 ? "s" : ""}` : "";
  return (
    <div
      className="mb-1.5 flex items-start gap-1.5 bg-orange-500/10 border border-orange-500/40 rounded-sm px-2 py-1 text-[10px] text-orange-800"
      data-testid={testid}
      title={calls
        .slice(0, 5)
        .map((c) => `${c.telepro_code} · ${STATUS_BY_ID[c.status]?.short || c.status} · ${_relDay(c.at)}${c.note ? " · " + c.note : ""}`)
        .join("\n")}
    >
      <Warning size={11} weight="fill" className="text-orange-600 shrink-0 mt-0.5"/>
      <div className="flex flex-wrap items-center gap-x-1">
        <span className="font-bold uppercase tracking-wider">Déjà appelée</span>
        <span className="normal-case tracking-normal">
          par <b className="font-mono">{last.telepro_code}</b>
          {" · "}
          <b className="normal-case">{statusLabel}</b>
          {" · "}
          {_relDay(last.at)}
          {others}
        </span>
      </div>
    </div>
  );
}
